import React from 'react'

function Areas() {
  return (
    <div>Areas</div>
  )
}

export default Areas